import loadApp from '~/services/bootstrap';
import App from './app.vue';

loadApp('#public-service-loan-forgiveness-calculator-app', App);
